import React, { useState, useEffect } from "react";
import { FiCopy, FiTrash2, FiPlus } from "react-icons/fi";
import "./Webinars.scss";
import WebinarModal from "./CreateWebinarModal/CreateWebinarModal";
import { IoCalendarOutline } from "react-icons/io5";
import { RxUpdate } from "react-icons/rx";
import { useNavigate, Link } from "react-router-dom";
import {
	createWebinar,
	getAllWebinars,
	deleteWebinar,
	getUserAvailability,
	getWebinarsByCommunityId,
	editWebinar,
	sendCommunityUpdate
} from "../../../Service/user";
import { HiVideoCamera } from "react-icons/hi";
import { useSelector } from "react-redux";
import  SharePopup  from "../../PopUp/SocialSharePopup/SharePopup";
import axios from "axios";
import { environment } from "../../../environments/environment";
import { Modal } from "react-bootstrap";
import { FaShare } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { MdEmail, MdPhone, MdPayment } from 'react-icons/md';
import { FaRegCalendarPlus } from 'react-icons/fa';
import { RiVideoAddFill } from 'react-icons/ri';


// Function to generate a random light color
const getRandomLightColor = () => {
	const r = Math.floor(Math.random() * 156 + 100); // Red value between 100-255
	const g = Math.floor(Math.random() * 156 + 100); // Green value between 100-255
	const b = Math.floor(Math.random() * 156 + 100); // Blue value between 100-255
	return `rgb(${r}, ${g}, ${b})`;
};

const Spinner = ({ isInvestor }) => (
	<div className="webinar-loader-container">
		<div
			className={`${
				isInvestor === "true" ? "webinar-investor-loader" : "webinar-loader"
			}`}
		>
			<div className="webinar-loader-inner"></div>
		</div>
	</div>
);

const isWebinarExpired = (startTime, duration) => {
	const webinarEndTime = new Date(startTime).getTime() + duration * 60 * 1000;
	return new Date().getTime() > webinarEndTime;
};

const EventsList = ({ communityId }) => {
	const navigate = useNavigate();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [events, setEvents] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingAdminStatus, setLoadingAdminStatus] = useState(false);
	const [copiedLinks, setCopiedLinks] = useState({});
	const [userAvailability, setUserAvailability] = useState({});
	const [isInvestor, setIsInvestor] = useState(false);
	const [isCommunityAdmin, setIsCommunityAdmin] = useState(false);
	const [selectedWebinarUsers, setSelectedWebinarUsers] = useState(null);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [selectedWebinar, setSelectedWebinar] = useState(null);
	const [sharePopupOpen, setSharePopupOpen] = useState(false);
	const [socialUrl, setSocialUrl] = useState("");
	const [selectedWebinarId, setSelectedWebinarId] = useState(null);
	const [showUserDetails, setShowUserDetails] = useState(false);

	console.log("isInvestor", isInvestor, typeof isInvestor);

	const loggedInUser = useSelector((state) => state.user.loggedInUser);
	const path =
		isInvestor === "true"
			? "/investor/meeting/availability"
			: "/meeting/availability";

	const fetchEvents = () => {
		setLoading(true);

		if (communityId) {
			getWebinarsByCommunityId(communityId)
				.then((response) => {
					setLoading(false);
					if (response && response.data) {
						setEvents(response.data);
					} else {
						console.error("Unexpected data format:", response);
					}
				})
				.catch((error) => {
					setLoading(false);
					console.error("Error fetching events:", error);
				});
			return;
		} else {
			getAllWebinars()
				.then((response) => {
					setLoading(false);
					if (response && response.data) {
						setEvents(response.data);
					} else {
						console.error("Unexpected data format:", response);
					}
				})
				.catch((error) => {
					setLoading(false);
					console.error("Error fetching events:", error);
				});
		}
	};

	useEffect(() => {
		setIsInvestor(loggedInUser.isInvestor);
		fetchEvents();

		// Check if user is community admin when communityId is provided
		if (communityId) {
			const checkAdminStatus = async () => {
				setLoadingAdminStatus(true);
				try {
					const response = await axios.get(
						`${environment.baseUrl}/communities/getCommunityById/${communityId}`
					);
					setIsCommunityAdmin(
						response.data.data.adminId._id === loggedInUser._id
					);
				} catch (error) {
					console.error("Error checking admin status:", error);
				} finally {
					setLoadingAdminStatus(false);
				}
			};
			checkAdminStatus();
		}
	}, [communityId, loggedInUser._id]);

	useEffect(() => {
		// Fetch user availability
		const fetchAvailability = async () => {
			try {
				const response = await getUserAvailability();
				if (response.status === 200) {
					setUserAvailability(response.availability);
				}
			} catch (error) {
				console.error(error);
			}
		};

		fetchAvailability();
	}, []);

	const handleCreateEvent = (eventData) => {
		// Add community ID to event data if it exists
		const eventDataWithCommunity = communityId
			? { ...eventData, community: communityId, webinarType: "Private" }
			: eventData;

		createWebinar(eventDataWithCommunity)
			.then(async (res) => {
				if (res.status === 200) {
					alert("Webinar created successfully");
					
					// Send community update email if this is a community webinar
					if (communityId) {
						try {
							await sendCommunityUpdate({
								communityId: communityId,
								updateType: "Event",
								description: `A new webinar "${eventData.title}" has been scheduled in the community for ${formatDate(eventData.startTime)}.`
							});
						} catch (error) {
							console.error("Failed to send community update:", error);
						}
					}
					
					fetchEvents();
				} else {
					alert("Error creating event");
				}
			})
			.catch((error) =>{
				alert(error.response.data.message || "Error Creating Event")
			});

		setIsModalOpen(false);
	};

	const handleDeleteEvent = (eventId) => {
		deleteWebinar(eventId)
			.then((res) => {
				if (res.status === 200) {
					alert("Webinar deleted successfully");
					fetchEvents();
				} else {
					alert("Error deleting event");
				}
			})
			.catch(() => {
				alert("Error deleting event");
			});
	};
	const formatDate = (dateString) => {
		const options = {
			year: "numeric",
			month: "long",
			day: "numeric",
			// hour: "2-digit",
			// minute: "2-digit",
			// hour12: true,
		};

		const date = new Date(dateString);
		return date.toLocaleDateString("en-IN", options);
	};

	const handleShowUserDetails = (event, e) => {
		e.stopPropagation();
		setSelectedWebinarUsers(event.joinedUsers || []);
		setShowUserDetails(true);
	};

	const handleCloseUserDetails = () => {
		setSelectedWebinarUsers(null);
	};

	const handleEditEvent = (event, e) => {
		e.stopPropagation(); // Prevent event bubbling to parent card click
		setSelectedWebinar(event);
		setIsEditModalOpen(true);
	};

	const handleEditSubmit = (editedData) => {
		editWebinar(selectedWebinar._id, editedData)
			.then((res) => {
				if (res.status === 200) {
					alert("Webinar updated successfully");
					fetchEvents();
				} else {
					alert("Error updating webinar");
				}
			})
			.catch(() => alert("Error updating webinar"));

		setIsEditModalOpen(false);
		setSelectedWebinar(null);
	};

	const handleWebinarAction = (event, e) => {
		e.stopPropagation();
		const webinarUrl = `/webinar/join-webinar/${event?.userId?.userName}/${event._id}`;
		
		// If user is the webinar creator, directly join
		if (event.userId._id === loggedInUser._id) {
			e.stopPropagation();
			window.open(event.link, '_blank');
			return;
		}

		// If not creator, redirect to registration page
		navigate(webinarUrl);
	};

	const isUserRegistered = (event) => {
		return event.joinedUsers?.some(user => user.email === loggedInUser.email);
	};

	if (loading) {
		return <Spinner isInvestor={isInvestor} />;
	}

	return (
		<div className="events-container">
			<div className="events-header">
				{!communityId && (<h1>Webinars</h1>)}
				{/* Show create button only if no communityId OR user is community admin */}
				{(!communityId || (isCommunityAdmin && !loadingAdminStatus)) &&
					(userAvailability ? (
						<button
							className="create-event-btn"
							onClick={() => setIsModalOpen(true)}
						>
							<FiPlus />
							<span>Create Webinar</span>
						</button>
					) : (
						<button className="create-event-btn" onClick={() => navigate(path)}>
							<RxUpdate />
							<span>Set Availability</span>
						</button>
					))}
			</div>

			{events.length === 0 ? (
				<div className="no-events">{communityId ? "No Webinars for this community available." : "No webinars found."}</div>
			) : (
				<div className="events-grid">
					{events.map((event, index) => (
						<div
							key={index}
							className="event-card"
							style={{ backgroundColor: getRandomLightColor() }}
						>
							<div className="event-info">
								<h3>{event.title}</h3>

								<div className="event-meta">
									<div className="leftTime">
										<span>
											<IoCalendarOutline size={20} />
										</span>{" "}
										&nbsp;&nbsp;
										<span>{formatDate(event.startTime)}</span>
										<span className="separator">|</span> &nbsp;&nbsp;
										<span>{event.duration} mins</span> &nbsp;&nbsp;
									</div>
									<div className="leftRight">
										{event?.price > 0 ? (
											<div className="price-tag">
												{event?.discount > 0 && (
													<span className="original-price">
														₹{event?.price}
													</span>
												)}
												<span className="new-price">
													₹
													{(event?.price * (1 - event?.discount / 100)).toFixed(
														0
													)}
												</span>
											</div>
										) : (
											<div className="price-tag">
												<b>Free</b>
											</div>
										)}
									</div>
								</div>

								<div className="bookings-details">
									<div className="bookings-count">
										{event.joinedUsers.length}{" "}
										{event.joinedUsers.length === 1
											? "User Joined"
											: "Users Joined"}
									</div>
									{event.joinedUsers.length > 0 &&
										event.userId._id === loggedInUser._id && (
											<button
												className="view-users-btn"
												onClick={(e) =>
													handleShowUserDetails(event, e)}
											>
												View Guests
											</button>
										)}
								</div>
							</div>
							{isWebinarExpired(event.startTime, event.duration) && (
								<div className="expired-status">
									<div className="expired-badge">
										Expired
									</div>
								</div>
							)}
							<div className="event-actions">
								<div className="action-buttons">
									{event.userId._id === loggedInUser._id ? (
										// Webinar creator - show join meeting
										<button
											className="join-btn"
											onClick={(e) => {
												e.stopPropagation();
												window.open(event.link, '_blank');
											}}
											disabled={isWebinarExpired(event.startTime, event.duration)}
										>
											Join Meeting
										</button>
									) : (
										// Not the creator - show register or join based on registration status
										<button
											className={`${isUserRegistered(event) ? 'join-btn' : 'register-btn'}`}
											onClick={(e) => handleWebinarAction(event, e)}
											disabled={isWebinarExpired(event.startTime, event.duration)}
										>
											{isUserRegistered(event) ? (
												<>
													<RiVideoAddFill /> Join Meeting
												</>
											) : (
												<>
													<FaRegCalendarPlus /> Register for Event
												</>
											)}
										</button>
									)}

									{!isWebinarExpired(event.startTime, event.duration) && (
										<button
											className="share-btn"
											onClick={(e) => {
												e.stopPropagation();
												const webinarUrl = `${window.location.origin}/webinar/join-webinar/${event?.userId?.userName}/${event._id}`;
												setSocialUrl(webinarUrl);
												setSelectedWebinarId(event._id);
												setSharePopupOpen(true);
											}}
										>
											<FaShare /> Share
										</button>
									)}

									{event.userId._id === loggedInUser._id && (
										<button
											className="delete-btn"
											onClick={(e) => {
												e.stopPropagation();
												if (window.confirm('Are you sure you want to delete this webinar?')) {
													handleDeleteEvent(event._id);
												}
											}}
											disabled={isWebinarExpired(event.startTime, event.duration)}
										>
											<FiTrash2 /> Delete
										</button>
									)}
								</div>
							</div>
						</div>
					))}
				</div>
			)}

			{/* User Details Modal */}
			<Modal 
				show={showUserDetails} 
				onHide={() => setShowUserDetails(false)}
				className="user-details-modal-overlay"
				centered
				backdrop={false}
			>
				<Modal.Header closeButton>
					<h3>Registered Users</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="users-list">
						{selectedWebinarUsers?.length > 0 ? (
							selectedWebinarUsers.map((user, index) => (
								<div key={index} className="user-item">
									<div className="user-avatar">
										{user.name ? user.name.charAt(0).toUpperCase() : <FaUserCircle />}
									</div>
									<div className="user-info">
										<h4>{user.name}</h4>
										<div className="user-details">
											<p>
												<MdEmail />
												{user.email}
											</p>
											<p>
												<MdPhone />
												{user.mobile}
											</p>
											{user.paymentStatus && (
												<p>
													<MdPayment />
													<span className={`payment-status ${user.paymentStatus.toLowerCase()}`}>
														Payment: {user.paymentStatus}
														{user.paymentAmount && ` - ₹${user.paymentAmount}`}
													</span>
												</p>
											)}
										</div>
									</div>
								</div>
							))
						) : (
							<div className="no-users">
								No users have registered for this webinar yet.
							</div>
						)}
					</div>
				</Modal.Body>
			</Modal>

			<WebinarModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				onSubmit={handleCreateEvent}
			/>

			<WebinarModal
				isOpen={isEditModalOpen}
				onClose={() => {
					setIsEditModalOpen(false);
					setSelectedWebinar(null);
				}}
				onSubmit={handleEditSubmit}
				initialData={selectedWebinar}
				isEditing={true}
			/>

			<SharePopup
				postId={selectedWebinarId}
				isOpen={sharePopupOpen}
				setIsOpen={setSharePopupOpen}
				url={socialUrl}
			/>
		</div>
	);
};

export default EventsList;
